import { AmslerHistoryGrids } from './amsler-history-grids.component'
import { useTranslation } from 'react-i18next'
import { CurecallButton, CurecallModalContainer, ECurecallButtonAppearance } from '@honestica/curecall-ui'
import { TPatientForm } from 'src/types/form'

type AmslerGridModalProps = {
  onToggle: () => void
  history: TPatientForm[]
  displayMore: () => void
}

const AmslerGridModal = ({ onToggle, history, displayMore }: AmslerGridModalProps) => {
  const { t } = useTranslation()

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.close')}
      title={t('components.patient.patient-file.body.followup-details.amsler-grid')}
      isOpen={true}
      toggle={onToggle}
      dialogClassName="sm:c-w-[750px] xl:c-w-[900px]"
    >
      <div className="c-flex c-flex-row c-flex-wrap c-gap-10">
        {history && history.length > 0 ? (
          history.map((form) => <AmslerHistoryGrids key={form.id} form={form as any} />)
        ) : (
          <p>{t('components.patient.patient-file.body.followup-details.no-grid-found')}</p>
        )}
      </div>
      {history.length > 1 && (
        <CurecallButton appearance={ECurecallButtonAppearance['PRIMARY-OUTLINED']} onClick={displayMore}>
          {t('components.patient.patient-file.body.followup-details.see-more')}
        </CurecallButton>
      )}
    </CurecallModalContainer>
  )
}

export default AmslerGridModal
